<template>
  <div class="wraper" style="margin-top: 215px;">
    <lottery
        @lotteryClick="layerClick"
        @lotteryDone="lotteryDone"
        :lottery-start="lotteryStart"
        :lottery-prizenum="prizeNum"
        :lottery-prizeno="prizeNo"
        :lottery-bg="lotteryBg"
        :content-bg="contentBg"
        :pointer-bg="pointerBg"
        :lottery-width="['85%','35%']"
    />
  </div>
</template>
<!--
start = 0;
pNo = 1;
pNum = 8;
plist =['一等奖', '五等奖', '二等奖', '五等奖', '三等奖', '五等奖', '四等奖', '五等奖']
-->
<script>
export default {
  name: "BiorunLottery", data() {
    let start = 0;
    let pNo = 1;
    let pNum = 8;
    let pList = ['一等奖', '六等奖', '二等奖', '五等奖', '三等奖', '六等奖', '四等奖', '五等奖'];
    return {
      lotteryStart: start,
      prizeNo: pNo,
      prizeNum: pNum,
      prizeList: pList,
      lotteryBg:'./images/turnplate-bg.png',
      contentBg:'./images/turntable.png',
      pointerBg:'./images/pointer.png',
      pupup:0
    }
  },
  methods: {
    layerMsg: function(msg,herf){
      const layers = this.$confirm({
        title: '温馨提示:',
        msg: msg,
        sureTXT: '确认',
        cancleTXT: '取消'
      }).then((res) => {
        window.location.href = herf;
        console.info('确定:'+ res);
      }).catch((error) => {
        console.info('取消:'+ error);
      });
      return layers;
    },
    layerStaticMsg(msg){
      const layers = this.$confirm({
        title: '温馨提示:',
        msg: msg,
        sureTXT: '确认',
        cancleTXT: '取消'
      }).then((res) => {
        console.info('确定:'+ res);
      }).catch((error) => {
        console.info('取消:'+ error);
      });
      return layers;
    },
    resolveApiMsg: function(res, fallback){
      if(!res){
        return fallback || '网络异常，请稍后再试！';
      }
      if(res.data && res.data.msg){
        return res.data.msg;
      }
      if(res.msg){
        return res.msg;
      }
      return fallback || '请求失败，请稍后再试！';
    },
    getLotteryNum: async function(mobile){
      let ApiUrl = ''; // 同源调用，经本站反代到 API
      let data = { type:15,mobile:mobile,username:'mczn'};
      let emulatejson = { emulateJSON:true };
      //发送 post 请求
      const resData = this.axios({
        method:'post',
        url:ApiUrl +'/index/lottery/read',
        data:data,
        responseType:emulatejson
      }).then(function(response){
        return response.data;
      }).catch(function(error){
        console.log(error);
        return {code:500,msg:'网络异常，请稍后再试！',data:{msg:'网络异常，请稍后再试！'}};
      });
      return resData;
    },
    GetQueryString: function(name){
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
    getLotteryResult: async function(mobile){
      let ApiUrl = ''; // 同源调用，经本站反代到 API
      let data = { type:17,mobile:mobile,username:'mczn'};
      let emulatejson = { emulateJSON:true };
      //发送 post 请求
      const resData = this.axios({
        method:'post',
        url:ApiUrl +'/index/lottery/read',
        data:data,
        responseType:emulatejson
      }).then(function(response){
        return response.data;
      }).catch(function(error){
        console.log(error);
        return {code:500,msg:'网络异常，请稍后再试！',data:{msg:'网络异常，请稍后再试！'}};
      });
      return resData;
    },
    saveLotteryResult: async function(mobile,lottery){
      let ApiUrl = ''; // 同源调用，经本站反代到 API
      let data = {type:18,mobile:mobile,lottery_id:lottery,username:'mczn'};
      let emulatejson = { emulateJSON:true };
      //发送 post 请求
      const resData = this.axios({
        method:'post',
        url:ApiUrl +'/index/lottery/read',
        data:data,
        responseType:emulatejson
      }).then(function(response){
        return response.data;
      }).catch(function(error){
        console.log(error);
        return {code:500,msg:'网络异常，请稍后再试！',data:{msg:'网络异常，请稍后再试！'}};
      });
      return resData;
    },
    lotteryClick (data,result) {
      //执行抽奖的动作
      this.lotteryStart = data;
      // let randomNum = 1 + parseInt(Math.random() * this.prizeNum);
      let randomNum = result;
      this.prizeNo = randomNum;
    },
    lotteryDone (res) {
      //执行抽奖的结果
      this.lotteryStart = 0;
      let index = res.prizeNo - 1;
      let that = this;
      //2秒后执行结果的弹窗
      setTimeout(function(){
        let mobile = that.GetQueryString('id');
        let lotteryHref = window.location.protocol + '//lottery.oms.biorun.com/redeem.html?id=' + mobile;
        that.layerMsg('恭喜您获得 [ ' + that.prizeList[index] + ' ] ',lotteryHref);
      },1000);

      console.log(this.prizeList[index]);
    },
    layerClick(){
      //定义父系的选择
      let that = this;
      //2.获取剩下的产品和抽奖的结果
      let mobile = this.GetQueryString('id');
      //3.赋值抽奖结果
      let reslotttery = this.getLotteryNum(mobile);
      //4.获取抽奖的结果
      let responseData = reslotttery.then(function(res){
        let protalUrl = window.location.protocol + '//lottery.oms.biorun.com/login.html';
        if(!res){
          that.layerStaticMsg('网络异常，请稍后再试！');
          return;
        }
        if(res.code === 0){
          //1.获取返回值和抽奖的次数
          let num = res.data.lnum;
          if(num == 1){
            //2.获取抽奖结果
            let resultLottery = that.getLotteryResult(res.data.mobile);
            //3.分析抽奖的数据
            let resultData = resultLottery.then(function(result){
              if(!result || result.code !== 0 || !result.data || !result.data.lottery){
                that.layerStaticMsg(that.resolveApiMsg(result, '奖项已经抽完，下次再抽！'));
                return;
              }
              console.log(resultData);
              //3.开始执行抽奖
              that.lotteryClick(num, result.data.lottery);
              //4.执行中奖数据的写入
              that.saveLotteryResult(res.data.mobile, result.data.rid);
            });
          }else{
            if(mobile){
              let mobile = that.GetQueryString('id');
              let lotteryHref = window.location.protocol + '//lottery.oms.biorun.com/redeem.html?id=' + mobile;
              that.layerMsg('你已经摇过奖了，无法进行抽奖！',lotteryHref);
            }else{
              that.layerMsg('你未进行登记，无法进行抽奖！',protalUrl);
            }
          }
          console.log('BiorunLettoryVue:' + res.msg);
        }else{
          let failMsg = that.resolveApiMsg(res, '请求失败，请稍后再试！');
          // 未登记：确认后进入登记页；已摇过：进入兑奖页
          if(failMsg.indexOf('未进行登记') >= 0 || failMsg.indexOf('未登记') >= 0){
            that.layerMsg(failMsg, protalUrl);
          }else if(failMsg.indexOf('摇过') >= 0 && mobile){
            that.layerMsg(failMsg, window.location.protocol + '//lottery.oms.biorun.com/redeem.html?id=' + mobile);
          }else{
            that.layerStaticMsg(failMsg);
          }
          console.log('BiorunLettoryVue:' + res.msg);
        }
      });
      //console.log(reslotttery);
      console.log(responseData);
    }
  },
  watch:{}
}
</script>

<style scoped>
.wraper{width: 65%;margin: 0 auto;}
</style>
